const CoustomUrls = {
  signIn: `${process.env.REACT_APP_HOME_VISITS}/HomeVisits/login`,
  getAllUnits: `${process.env.REACT_APP_OFFERS_URL}/Attribute/GetAllUnits`,
  getUnitDetails: `${process.env.REACT_APP_OFFERS_URL}/Attribute/GetUnitDetails`,
  getUnitsPerCountry: `${process.env.REACT_APP_OFFERS_URL}/Attribute/GetUnitsPerCountry`,
  addEditUnit: `${process.env.REACT_APP_OFFERS_URL}/Attribute/AddUnit`,
  getAllServices: `${process.env.REACT_APP_OFFERS_URL}/portal/GetAllServicesByLevel`,
  getServiceDetails: `${process.env.REACT_APP_OFFERS_URL}/portal/GetServiceDetails`,
  addService: `${process.env.REACT_APP_OFFERS_URL}/portal/AddServiceAcrossCountries`,
  updateService: `${process.env.REACT_APP_OFFERS_URL}/portal/updateService`,
  getDoctorStatsData: `${process.env.REACT_APP_HOME_VISITS}/Supplier/stats`,
  searchDoctors: `${process.env.REACT_APP_DOCTORS_URL}/Search`,
  GetCitiesAreasByBookingType: `${
    process.env.REACT_APP_STATIC_URL
  }/api/Area/GetCitiesAreasByBookingType`,
  GetDropdowns: `${process.env.REACT_APP_DOCTORS_URL}/Generic/GetDropdowns`
};
export default CoustomUrls;
